import React from 'react';
import { Link } from 'react-router-dom';

// Shared left vertical settings rail, used by both CompanySettings and
// UserSettings. Renders the (already feature-filtered) sections, each linking
// to `${basePath}/${slug}` so sections are deep-linkable, and highlights the
// active one. Sections may optionally carry a `group` label — if any do, items
// are rendered under group headers; otherwise the rail is a flat list.
const SettingsRail = ({ basePath, activeSlug, sections }) => {
  const hasGroups = sections.some((s) => s.group);

  // Build groups preserving first-seen order. With no groups, everything goes
  // into a single untitled group (flat list).
  const groups = [];
  if (hasGroups) {
    sections.forEach((s) => {
      let group = groups.find((g) => g.title === s.group);
      if (!group) {
        group = { title: s.group, items: [] };
        groups.push(group);
      }
      group.items.push(s);
    });
  } else {
    groups.push({ title: null, items: sections });
  }

  return (
    <nav className="settings-rail" aria-label="Inställningar">
      {groups.map((group, gi) => (
        <div className="settings-rail-group" key={group.title || gi}>
          {group.title && <div className="settings-rail-group-title">{group.title}</div>}
          {group.items.map((s) => (
            <Link
              key={s.slug}
              to={`${basePath}/${s.slug}`}
              className={`settings-rail-item${s.slug === activeSlug ? ' is-active' : ''}`}
              aria-current={s.slug === activeSlug ? 'page' : undefined}
            >
              <s.Icon className="settings-rail-icon" size={18} strokeWidth={1.75} />
              <span className="settings-rail-label">{s.label}</span>
            </Link>
          ))}
        </div>
      ))}
    </nav>
  );
};

export default SettingsRail;
